// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".timer{line-height:24px;color:#bfbfbf;font-size:14px}", ""]);
// Exports
module.exports = exports;
